import * as logMessageTypes from '../../consts/log/logMessageTypes';
import * as dataCollectionTypes from '../../consts/uam/dataCollectionTypes';
import {setDeviceActivationStatus} from '../../state/ducks/iotDevice/actions';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../state/selectors/consumer';
import {selectIotDeviceData} from '../../state/selectors/iotDevice';
import {makeSelectAssetByType} from '../../state/selectors/yapEncrypted';
import {dispatch, getState} from '../../state/store';
import backendService from '../app/backendService';
import iccService from '../icc/iccService';
import log from '../logger/log';
import {uamActivationStatusMapping} from '../mapping/uamMappings';
import uamClientService from './uamClientService';

const checkDeviceActivationStatus = async () => {
    try {
        const isDeviceActivated = await getIsDeviceActivatedInUam();

        log.info(`uamWebSocketService: isDeviceActivated: ${isDeviceActivated}`, {logMessageType: logMessageTypes.UAM});

        dispatch(setDeviceActivationStatus(isDeviceActivated));
    } catch (e) {
        log.error(`uamWebSocketService: check activation action after failed status: ${e}`, {
            logMessageType: logMessageTypes.UAM,
        });
    }
};

const getIsDeviceActivatedInUam = async () => {
    const {assetId, yapActivated} = makeSelectAssetByType()(getState()) || {};

    if (assetId) return yapActivated;

    const {device} = makeSelectIotDeviceMergedWithConsumerProduct()(getState()) || {};
    const {codentifyOriginal} = device || {};

    if (!codentifyOriginal) {
        throw new Error(`Failed to get activation status. Codentify is empty`);
    }

    const response = await uamClientService.getActivationStatus(codentifyOriginal);

    if (!response) {
        throw new Error(`Failed to get activation status for ${codentifyOriginal}`);
    }

    const {isActivated} = uamActivationStatusMapping(response);

    return isActivated;
};

const checkDataCollectionFlow = async () => {
    const isUamBackend = backendService.isUamBackend();

    if (!isUamBackend) return;

    const iotDevice = selectIotDeviceData(getState());
    const {device} = iotDevice || {};

    if (!device) return;

    await uamClientService.cancelSynchronizeData({dataCollectionType: dataCollectionTypes.DATA_COLLECTION_GLOBAL});
    await iccService.fetchUamTokensIgnoreErrors();
};

export default {
    checkDataCollectionFlow,
    checkDeviceActivationStatus,
};
